import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import { downloadDocumentContent } from "web_myplann/Api/Document/downloadDocumentContent";
import type { OpenDocumentVariables } from "web_myplann/Api/Document/useOpenDocumentMutation";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { sessionState } from "web_myplann/Shared/State/sessionAtom";
import { device } from "web_myplann/Utils/device";

export const useSaveDocumentMutation = () => {
	const { token, tokenVerify, authorizationType } = useAtomValue(sessionState);
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: DocumentKeys.transfer,
		mutationFn: async ({
			id,
			fallbackTitle,
		}: OpenDocumentVariables): Promise<string[]> => {
			const errorMessage = t(Resources.Common.documentOpenFailed);

			const document = await downloadDocumentContent({
				id,
				fallbackTitle,
				token,
				tokenVerify,
				authorizationType,
				errorMessage,
			});

			const response = await device.saveAttachment(
				{
					filename: document.filename,
					base64: document.base64,
				},
				id,
			);

			if (!response.payload.success) {
				throw new Error(errorMessage);
			}

			if (response.payload.savedDocumentIds) {
				queryClient.setQueryData(
					DocumentKeys.saved,
					response.payload.savedDocumentIds,
				);
			}

			return response.payload.downloaded;
		},
	});
};
